import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Typography,
  Container,
  IconButton,
} from '@mui/material';
import { PersonAdd as PersonAddIcon } from '@mui/icons-material';
import { 
  VERDE_MENTA, 
  VERDE_MENTA_ESCURO, 
  VERDE_MENTA_CLARO,
  FUNDO_ESCURO,
  TEXTO_PRIMARIO,
  withAlpha 
} from '../../themes/themeConstants';

interface LandingMenuProps {
  currentPage?: 'home' | 'about' | 'features' | 'pricing' | 'contact';
}

/**
 * Menu de navegação compartilhado para as páginas de landing
 */
const LandingMenu: React.FC<LandingMenuProps> = ({ currentPage = 'home' }) => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" elevation={0} sx={{ backgroundColor: FUNDO_ESCURO, borderBottom: `1px solid ${withAlpha(VERDE_MENTA, 0.2)}` }}>
      <Container>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="home"
            onClick={() => navigate('/')}
            sx={{ 
              mr: 2, 
              color: VERDE_MENTA,
              '&:hover': {
                backgroundColor: withAlpha(VERDE_MENTA, 0.1)
              }
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </IconButton>
          <Typography variant="h5" component="div" sx={{ flexGrow: 1, fontWeight: 'bold', color: VERDE_MENTA }}>
            SimpleX
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              sx={{ 
                color: currentPage === 'about' ? VERDE_MENTA : TEXTO_PRIMARIO,
                fontWeight: currentPage === 'about' ? 'bold' : 'normal',
                borderBottom: currentPage === 'about' ? `2px solid ${VERDE_MENTA}` : 'none',
                borderRadius: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                }
              }} 
              onClick={() => navigate('/sobre')}
            >
              Sobre
            </Button>
            <Button 
              sx={{ 
                color: currentPage === 'features' ? VERDE_MENTA : TEXTO_PRIMARIO,
                fontWeight: currentPage === 'features' ? 'bold' : 'normal',
                borderBottom: currentPage === 'features' ? `2px solid ${VERDE_MENTA}` : 'none',
                borderRadius: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                }
              }} 
              onClick={() => navigate('/recursos')}
            >
              Recursos
            </Button>
            <Button 
              sx={{ 
                color: currentPage === 'pricing' ? VERDE_MENTA : TEXTO_PRIMARIO,
                fontWeight: currentPage === 'pricing' ? 'bold' : 'normal',
                borderBottom: currentPage === 'pricing' ? `2px solid ${VERDE_MENTA}` : 'none',
                borderRadius: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                }
              }} 
              onClick={() => navigate('/precos')}
            >
              Preços
            </Button>
            <Button 
              sx={{ 
                color: currentPage === 'contact' ? VERDE_MENTA : TEXTO_PRIMARIO,
                fontWeight: currentPage === 'contact' ? 'bold' : 'normal',
                borderBottom: currentPage === 'contact' ? `2px solid ${VERDE_MENTA}` : 'none',
                borderRadius: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                }
              }} 
              onClick={() => navigate('/contato')}
            >
              Contato
            </Button>
            <Button 
              variant="outlined" 
              onClick={() => navigate('/login')}
              sx={{
                color: VERDE_MENTA,
                borderColor: VERDE_MENTA,
                '&:hover': {
                  borderColor: VERDE_MENTA_CLARO,
                  backgroundColor: withAlpha(VERDE_MENTA, 0.1)
                }
              }}
            >
              Entrar
            </Button>
            <Button 
              variant="contained" 
              onClick={() => navigate('/register')}
              startIcon={<PersonAddIcon />}
              sx={{
                backgroundColor: VERDE_MENTA,
                color: '#000',
                '&:hover': {
                  backgroundColor: VERDE_MENTA_CLARO
                }
              }}
            >
              Registrar
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default LandingMenu;